/** @hidden */
export var __IGLTFExporterExtension = 0; // I am here to allow dts to be created